import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { Pagination } from '../types'

export const paginationSelector: Selector<ReduxState, Pagination> = state => state.processingCosts.pagination
export default paginationSelector
